module.exports = __webpack_public_path__ + "img/Tessellate20.1f52c708.jpg";